import axios, { type AxiosInstance, type AxiosResponse, type AxiosError } from 'axios'
import { ElMessage } from 'element-plus'
import { ADMIN_TOKEN_KEY, apiBaseURL } from '@/config/constants'

const service: AxiosInstance = axios.create({
  baseURL: apiBaseURL(),
  timeout: 60_000,
})

service.interceptors.request.use((config) => {
  const headers = config.headers ?? {}
  const tok = localStorage.getItem(ADMIN_TOKEN_KEY)
  if (tok?.trim()) {
    const t = tok.trim()
    headers.Authorization = /^bearer\s+/i.test(t) ? t : `Bearer ${t}`
  }
  config.headers = headers
  return config
})

service.interceptors.response.use(
  (res: AxiosResponse) => res,
  (err: AxiosError<{ message?: string }>) => {
    const msg =
      err.response?.status === 401
        ? '未登录或 token 失效'
        : err.response?.data?.message ?? err.response?.statusText ?? err.message
    ElMessage.error(String(msg || '请求失败'))
    return Promise.reject(err)
  }
)

/** loan-java `@RequestParam` POST 表单 */
export function adminForm(body: Record<string, string | number | boolean | undefined>) {
  const fd = new URLSearchParams()
  for (const [k, v] of Object.entries(body)) {
    if (v !== undefined && v !== null) fd.append(k, String(v))
  }
  return fd
}

export default service
